import { render, staticRenderFns } from "./PayrollModal.vue?vue&type=template&id=fa705eca&"
import script from "./PayrollModal.vue?vue&type=script&lang=js&"
export * from "./PayrollModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports